import * as z from "zod";
import type { Ctx } from "../../types";
import { FormAction } from "gg-wf-scripts";
import { toast } from "../../toast";
import { invokeApi, parse } from "../_helpers";

const request_password_reset_schema = z.object({
  email: z.email("Please enter a valid email"),
});

export const request_password_reset: FormAction<Ctx> = async (
  { sb },
  formData,
  _params
) => {
  const parsed = parse(request_password_reset_schema, formData);
  if (!parsed.ok) return parsed;

  const result = await invokeApi(sb, "api/auth/password-reset", {
    method: "POST",
    body: parsed.data,
  });
  if (!result.ok) {
    if (result.field_errors.length === 0) {
      toast({
        variant: "error",
        text: result.error ?? "Couldn't send reset link. Please try again.",
      });
    }
    return result;
  }

  toast({
    variant: "success",
    text: "Password reset email sent!",
  });
  return result;
};
